import React, { useState, useEffect } from 'react';
import styles from './402.module.scss';
import API_BASE_URL from '../../../config/api';
import { useAuth } from '../../../context/AuthContext';
import mwuLogo from '../mwu-logo.webp';

const Form402 = () => {
      const { makeAuthenticatedRequest } = useAuth();
      const [activeTab, setActiveTab] = useState('main');
             const [signatures, setSignatures] = useState({
         fontwalSignature: null,
         branchHeadSignature: null,
         officeHeadSignature: null
       });
       const [signatureVisibility, setSignatureVisibility] = useState({
         fontwalSignature: false,
         branchHeadSignature: false,
         officeHeadSignature: false
       });
        const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formId, setFormId] = useState(null);
     const [formData, setFormData] = useState({
       office: '',
       officeAddress: '',
       officeCode: '',
       orderNumber: '',
      orderDate: '',
      decisionNumber: '',
      applicationDate: '',
      personName: '',
      entityName: '',
      address: '',
      phoneNumber: '',
      registrationNumber: '',
      panNumber: '',
      deliveryDate: '',
      deliveryOffice: '',
      deliveryLocation: '',
      items: [],
      totalAmount: '',
      vatAmount: '',
      grandTotal: '',
      deliveryDate2: '',
      deliveryOffice2: '',
      deliveryLocation2: '',
      fontwalName: '',
      fontwalDate: '',
      branchHeadName: '',
      branchHeadDate: '',
      officeHeadName: '',
      officeHeadDate: '',
      firmName: '',
      firmSignature: '',
      firmDate: ''
    });
         const [dynamicRows, setDynamicRows] = useState([]);
     const [emptyRows, setEmptyRows] = useState([
       { id: 'empty-1', serialNumber: '1', classificationCode: '', itemName: '', specification: '', unit: '', quantity: '', rate: '', total: '', remarks: '' },
       { id: 'empty-2', serialNumber: '2', classificationCode: '', itemName: '', specification: '', unit: '', quantity: '', rate: '', total: '', remarks: '' },
       { id: 'empty-3', serialNumber: '3', classificationCode: '', itemName: '', specification: '', unit: '', quantity: '', rate: '', total: '', remarks: '' },
       { id: 'empty-4', serialNumber: '4', classificationCode: '', itemName: '', specification: '', unit: '', quantity: '', rate: '', total: '', remarks: '' },
       { id: 'empty-5', serialNumber: '5', classificationCode: '', itemName: '', specification: '', unit: '', quantity: '', rate: '', total: '', remarks: '' },
       { id: 'empty-6', serialNumber: '6', classificationCode: '', itemName: '', specification: '', unit: '', quantity: '', rate: '', total: '', remarks: '' }
     ]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleInputResize = (e) => {
    const input = e.target;
    const minWidth = 80;
    const maxWidth = 400;
    const charWidth = 8; // Approximate width per character
    
    const textWidth = input.value.length * charWidth;
    const newWidth = Math.max(minWidth, Math.min(maxWidth, textWidth + 20)); // +20 for padding
    
    input.style.width = `${newWidth}px`;
  };

  const handleInputChangeWithResize = (field, value, e) => {
    handleInputChange(field, value);
    handleInputResize(e);
  };

  const handleSignatureUpload = (type, file) => {
    if (file) {
      console.log(`Uploading ${type}:`, file.name, file.size, file.type);
      const reader = new FileReader();
      reader.onload = (e) => {
        console.log(`File loaded for ${type}:`, e.target.result.substring(0, 50) + '...');
        setSignatures(prev => ({
          ...prev,
          [type]: {
            file: file,
            preview: e.target.result
          }
        }));
      };
      reader.readAsDataURL(file);
    } else {
      console.log(`No file selected for ${type}`);
    }
  };

    const saveSignatures = async () => {
    const hasNewSignatures = signatures.fontwalSignature?.file || 
                            signatures.branchHeadSignature?.file || 
                            signatures.officeHeadSignature?.file;
    
    if (!hasNewSignatures) {
      alert('कुनै नयाँ दस्तखत अपलोड गरिएको छैन!');
      return;
    }

    // If no formId exists, create a new form with just signatures
    let currentFormId = formId;
    if (!currentFormId) {
      try {
        // Create a minimal form with just signatures
        const minimalFormData = new FormData();
        
        // Add signature files to the initial form creation
        if (signatures.fontwalSignature?.file) {
          minimalFormData.append('fontwal_signature', signatures.fontwalSignature.file);
        }
        if (signatures.branchHeadSignature?.file) {
          minimalFormData.append('branch_head_signature', signatures.branchHeadSignature.file);
        }
        if (signatures.officeHeadSignature?.file) {
          minimalFormData.append('office_head_signature', signatures.officeHeadSignature.file);
        }

        console.log('Creating new form with signatures...');
        const createResponse = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form402/`, {
          method: 'POST',
          body: minimalFormData
        });

                 if (createResponse.ok) {
           const result = await createResponse.json();
           currentFormId = result.id;
           setFormId(result.id);
           // Save form ID to localStorage for persistence
           localStorage.setItem('lastForm402Id', result.id);
           console.log('New form created with signatures:', result);
           alert('दस्तखतहरु सफलतापूर्वक सेभ गरियो!');
           console.log('About to load form data for ID:', result.id);
           await loadFormData(result.id);
           console.log('Form data loaded after signature save');
           return;
        } else {
          const errorData = await createResponse.json();
          console.error('Error creating form:', errorData);
          alert(`दस्तखत सेभ गर्नेमा समस्या भयो: ${errorData.message || 'Unknown error'}`);
          return;
        }
      } catch (error) {
        console.error('Error creating form with signatures:', error);
        alert('दस्तखत सेभ गर्नेमा समस्या भयो!');
        return;
      }
    }

    // If formId exists, update the existing form with signatures
    try {
      const formData = new FormData();

      // Add signature files (only if they exist)
      if (signatures.fontwalSignature?.file) {
        formData.append('fontwal_signature', signatures.fontwalSignature.file);
        console.log('Adding fontwal signature:', signatures.fontwalSignature.file.name);
      }
      if (signatures.branchHeadSignature?.file) {
        formData.append('branch_head_signature', signatures.branchHeadSignature.file);
        console.log('Adding branch head signature:', signatures.branchHeadSignature.file.name);
      }
      if (signatures.officeHeadSignature?.file) {
        formData.append('office_head_signature', signatures.officeHeadSignature.file);
        console.log('Adding office head signature:', signatures.officeHeadSignature.file.name);
      }

      console.log('Saving signatures for form ID:', currentFormId);
      console.log('FormData entries:', Array.from(formData.entries()));

      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form402/${currentFormId}/`, {
        method: 'PATCH',
        body: formData
      });

      console.log('Response status:', response.status);
      console.log('Response ok:', response.ok);

             if (response.ok) {
         const result = await response.json();
         console.log('Signatures saved successfully:', result);
         
         // After successful save, reload the form data to get the updated signature URLs
         console.log('About to reload form data for ID:', currentFormId);
         await loadFormData(currentFormId);
         console.log('Form data reloaded after signature update');
         
         alert('दस्तखतहरु सफलतापूर्वक सेभ गरियो!');
      } else {
        const errorData = await response.json();
        console.error('Error response:', errorData);
        alert(`दस्तखत सेभ गर्नेमा समस्या भयो: ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error saving signatures:', error);
      alert('दस्तखत सेभ गर्नेमा समस्या भयो!');
    }
  };

     const handleSignatureDelete = (type) => {
     setSignatures(prev => ({
       ...prev,
       [type]: null
     }));
     
     // If form is saved, also delete from backend
     if (formId) {
       // Note: You might want to add a backend endpoint to delete specific signatures
       // For now, we'll just update the local state
       console.log(`Deleted signature: ${type}`);
     }
   };

   const toggleSignatureVisibility = (type) => {
     setSignatureVisibility(prev => ({
       ...prev,
       [type]: !prev[type]
     }));
   };

  const generateSignature = (type) => {
    // Create a simple signature placeholder
    const canvas = document.createElement('canvas');
    canvas.width = 200;
    canvas.height = 100;
    const ctx = canvas.getContext('2d');
    
    // Set background
    ctx.fillStyle = '#f8f9fa';
    ctx.fillRect(0, 0, 200, 100);
    
    // Draw border
    ctx.strokeStyle = '#dee2e6';
    ctx.lineWidth = 1;
    ctx.strokeRect(0, 0, 200, 100);
    
    // Draw signature text
    ctx.fillStyle = '#6c757d';
    ctx.font = '16px Arial';
    ctx.textAlign = 'center';
    
    const signatureTexts = {
      fontwalSignature: 'फाँटवालाको दस्तखत',
      branchHeadSignature: 'शाखा प्रमुखको दस्तखत',
      officeHeadSignature: 'कार्यालय प्रमुखको दस्तखत'
    };
    
    ctx.fillText(signatureTexts[type], 100, 50);
    ctx.font = '12px Arial';
    ctx.fillText('(Auto Generated)', 100, 70);
    
    // Convert to blob and create file
    canvas.toBlob((blob) => {
      const file = new File([blob], `${type}_signature.png`, { type: 'image/png' });
      handleSignatureUpload(type, file);
    }, 'image/png');
  };

  const loadFormData = async (id) => {
    if (!id) return;
    
    setIsLoading(true);
    try {
      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form402/${id}/`);
      if (response.ok) {
        const data = await response.json();
        console.log('Loaded form data:', data);
        console.log('Signature fields:', {
          fontwal: data.fontwal_signature,
          branch_head: data.branch_head_signature,
          office_head: data.office_head_signature
        });
        
        setFormData(prev => ({
          ...prev,
          ...data,
          items: data.items || prev.items
        }));
        setFormId(id);
        // Save form ID to localStorage for persistence
        localStorage.setItem('lastForm402Id', id);
        
                 // Load signatures if they exist
         if (data.fontwal_signature) {
           const signatureUrl = data.fontwal_signature.startsWith('http') 
             ? data.fontwal_signature 
             : `${API_BASE_URL}${data.fontwal_signature}`;
           console.log('Setting fontwal signature URL:', signatureUrl);
           setSignatures(prev => ({
             ...prev,
             fontwalSignature: {
               file: null,
               preview: signatureUrl
             }
           }));
         }
         if (data.branch_head_signature) {
           const signatureUrl = data.branch_head_signature.startsWith('http') 
             ? data.branch_head_signature 
             : `${API_BASE_URL}${data.branch_head_signature}`;
           console.log('Setting branch head signature URL:', signatureUrl);
           setSignatures(prev => ({
             ...prev,
             branchHeadSignature: {
               file: null,
               preview: signatureUrl
             }
           }));
         }
         if (data.office_head_signature) {
           const signatureUrl = data.office_head_signature.startsWith('http') 
             ? data.office_head_signature 
             : `${API_BASE_URL}${data.office_head_signature}`;
           console.log('Setting office head signature URL:', signatureUrl);
           setSignatures(prev => ({
             ...prev,
             officeHeadSignature: {
               file: null,
               preview: signatureUrl
             }
           }));
         }
      }
    } catch (error) {
      console.error('Error loading form data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Check for form ID in URL or localStorage on component mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    
    if (id) {
      loadFormData(id);
    } else {
      // Try to load the most recent form from localStorage
      const savedFormId = localStorage.getItem('lastForm402Id');
      if (savedFormId) {
        loadFormData(savedFormId);
      }
    }
  }, []);

     const handleItemChange = (index, field, value) => {
     const newItems = [...formData.items];
     newItems[index] = {
       ...newItems[index],
       [field]: value
     };
     setFormData(prev => ({
       ...prev,
       items: newItems
     }));
   };

       const addDynamicRow = () => {
      const newRowNumber = emptyRows.length + dynamicRows.length + 1; // Start after existing rows
      const newRow = {
        id: Date.now() + Math.random(), // Unique ID for the row
        serialNumber: newRowNumber.toString(),
        classificationCode: '',
        itemName: '',
        specification: '',
        unit: '',
        quantity: '',
        rate: '',
        total: '',
        remarks: ''
      };
      setDynamicRows(prev => [...prev, newRow]);
    };

       const removeDynamicRow = (rowId) => {
      setDynamicRows(prev => prev.filter(row => row.id !== rowId));
      // Recalculate serial numbers after removal
      setTimeout(() => {
        setDynamicRows(prev => prev.map((row, index) => ({
          ...row,
          serialNumber: (emptyRows.length + index + 1).toString()
        })));
      }, 0);
    };

       const handleDynamicRowChange = (rowId, field, value) => {
      setDynamicRows(prev => prev.map(row => 
        row.id === rowId ? { ...row, [field]: value } : row
      ));
    };

    const handleEmptyRowChange = (rowId, field, value) => {
      setEmptyRows(prev => prev.map(row => 
        row.id === rowId ? { ...row, [field]: value } : row
      ));
    };

    const removeEmptyRow = (rowId) => {
      setEmptyRows(prev => prev.filter(row => row.id !== rowId));
      // Recalculate serial numbers after removal
      setTimeout(() => {
        setEmptyRows(prev => prev.map((row, index) => ({
          ...row,
          serialNumber: (index + 1).toString()
        })));
      }, 0);
    };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (isSubmitting) return;
    setIsSubmitting(true);
    
    try {
      // Create FormData to handle file uploads
      const submitData = new FormData();
      
      // Add form data
      Object.keys(formData).forEach(key => {
        if (key === 'items') {
          submitData.append(key, JSON.stringify(formData[key]));
        } else {
          submitData.append(key, formData[key]);
        }
      });
      
      // Add signature files
      if (signatures.fontwalSignature?.file) {
        submitData.append('fontwal_signature', signatures.fontwalSignature.file);
      }
      if (signatures.branchHeadSignature?.file) {
        submitData.append('branch_head_signature', signatures.branchHeadSignature.file);
      }
      if (signatures.officeHeadSignature?.file) {
        submitData.append('office_head_signature', signatures.officeHeadSignature.file);
      }
      
      // Make API call
      const url = formId ? `${API_BASE_URL}/api/form402/${formId}/` : `${API_BASE_URL}/api/form402/`;
      const method = formId ? 'PUT' : 'POST';
      
      const response = await makeAuthenticatedRequest(url, {
        method: method,
        body: submitData,
        headers: {
          // Don't set Content-Type for FormData, let browser set it with boundary
        }
      });
      
                   if (response.ok) {
        const result = await response.json();
        alert('फारम सफलतापूर्वक सेभ गरियो!');
        console.log('Form saved successfully:', result);
        
        // Set form ID for new forms
        if (!formId && result.id) {
          setFormId(result.id);
          // Reload form data to get the updated signature URLs
          await loadFormData(result.id);
        } else if (formId) {
          // Reload form data for existing forms to get updated signature URLs
          await loadFormData(formId);
        }
        
        // Optionally reset form or redirect
        // window.location.reload();
      } else {
        const errorData = await response.json();
        alert(`फारम सेभ गर्नेमा समस्या भयो: ${errorData.message || 'Unknown error'}`);
      }
      
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('फारम सेभ गर्नेमा समस्या भयो!');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <div className={styles['form402-container']}>
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <p>फारम लोड गर्दै...</p>
        </div>
      </div>
    );
  }

  // Debug: Log current signatures state
  console.log('Current signatures state:', signatures);
  
  return (
    <div className={styles['form402-container']}>
      {/* Tab Navigation */}
      <div className={styles['tab-navigation']}>
        <button 
          className={`${styles['tab-button']} ${activeTab === 'main' ? styles.active : ''}`}
          onClick={() => setActiveTab('main')}
        >
          मुख्य फारम
        </button>
        <button 
          className={`${styles['tab-button']} ${activeTab === 'signature' ? styles.active : ''}`}
          onClick={() => setActiveTab('signature')}
        >
          दस्तखत
        </button>
      </div>

      {/* Signature Upload Tab */}
      {activeTab === 'signature' && (
        <div className={styles['signature-tab']}>
          <h2>दस्तखत अपलोड</h2>
          <div className={styles['signature-upload-section']}>
            <div className={styles['signature-item']}>
              <h3>फाँटवालाको दस्तखत</h3>
              <div className={styles['signature-upload-area']}>
                <input
                  type="file"
                  accept="image/*"
                  id="fontwal-signature-upload"
                  onChange={(e) => handleSignatureUpload('fontwalSignature', e.target.files[0])}
                  style={{ display: 'none' }}
                />
                <label 
                  className={styles['signature-upload-label']}
                  htmlFor="fontwal-signature-upload"
                >
                  {signatures.fontwalSignature ? (
                    <div className={styles['signature-preview']}>
                      <button 
                        type="button"
                        className={styles['delete-signature-btn']}
                        onClick={(e) => {
                          e.preventDefault();
                          handleSignatureDelete('fontwalSignature');
                        }}
                        title="दस्तखत मेटाउनुहोस्"
                      >
                        ✕
                      </button>
                                             <img 
                         src={signatures.fontwalSignature.preview} 
                         alt="फाँटवालाको दस्तखत" 
                         className={styles['signature-image']}
                       />
                       <p>{signatures.fontwalSignature.file ? signatures.fontwalSignature.file.name : 'Saved Signature'}</p>
                    </div>
                  ) : (
                    <div className={styles['signature-placeholder']}>
                      <span>📄</span>
                      <p>फाँटवालाको दस्तखत अपलोड गर्नुहोस्</p>
                    </div>
                  )}
                </label>
              </div>
              <button 
                type="button"
                onClick={() => generateSignature('fontwalSignature')}
                style={{
                  marginTop: '10px',
                  padding: '8px 16px',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                दस्तखत जनरेट गर्नुहोस्
              </button>
            </div>

            <div className={styles['signature-item']}>
              <h3>शाखा प्रमुखको दस्तखत</h3>
              <div className={styles['signature-upload-area']}>
                <input
                  type="file"
                  accept="image/*"
                  id="branch-head-signature-upload"
                  onChange={(e) => handleSignatureUpload('branchHeadSignature', e.target.files[0])}
                  style={{ display: 'none' }}
                />
                <label 
                  className={styles['signature-upload-label']}
                  htmlFor="branch-head-signature-upload"
                >
                  {signatures.branchHeadSignature ? (
                    <div className={styles['signature-preview']}>
                      <button 
                        type="button"
                        className={styles['delete-signature-btn']}
                        onClick={(e) => {
                          e.preventDefault();
                          handleSignatureDelete('branchHeadSignature');
                        }}
                        title="दस्तखत मेटाउनुहोस्"
                      >
                        ✕
                      </button>
                                             <img 
                         src={signatures.branchHeadSignature.preview} 
                         alt="शाखा प्रमुखको दस्तखत" 
                         className={styles['signature-image']}
                       />
                       <p>{signatures.branchHeadSignature.file ? signatures.branchHeadSignature.file.name : 'Saved Signature'}</p>
                    </div>
                  ) : (
                    <div className={styles['signature-placeholder']}>
                      <span>📄</span>
                      <p>शाखा प्रमुखको दस्तखत अपलोड गर्नुहोस्</p>
                    </div>
                  )}
                </label>
              </div>
              <button 
                type="button"
                onClick={() => generateSignature('branchHeadSignature')}
                style={{
                  marginTop: '10px',
                  padding: '8px 16px',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                दस्तखत जनरेट गर्नुहोस्
              </button>
            </div>

            <div className={styles['signature-item']}>
              <h3>कार्यालय प्रमुखको दस्तखत</h3>
              <div className={styles['signature-upload-area']}>
                <input
                  type="file"
                  accept="image/*"
                  id="office-head-signature-upload"
                  onChange={(e) => handleSignatureUpload('officeHeadSignature', e.target.files[0])}
                  style={{ display: 'none' }}
                />
                <label 
                  className={styles['signature-upload-label']}
                  htmlFor="office-head-signature-upload"
                >
                  {signatures.officeHeadSignature ? (
                    <div className={styles['signature-preview']}>
                      <button 
                        type="button"
                        className={styles['delete-signature-btn']}
                        onClick={(e) => {
                          e.preventDefault();
                          handleSignatureDelete('officeHeadSignature');
                        }}
                        title="दस्तखत मेटाउनुहोस्"
                      >
                        ✕
                      </button>
                                             <img 
                         src={signatures.officeHeadSignature.preview} 
                         alt="कार्यालय प्रमुखको दस्तखत" 
                         className={styles['signature-image']}
                       />
                       <p>{signatures.officeHeadSignature.file ? signatures.officeHeadSignature.file.name : 'Saved Signature'}</p>
                    </div>
                  ) : (
                    <div className={styles['signature-placeholder']}>
                      <span>📄</span>
                      <p>कार्यालय प्रमुखको दस्तखत अपलोड गर्नुहोस्</p>
                    </div>
                  )}
                </label>
              </div>
              <button 
                type="button"
                onClick={() => generateSignature('officeHeadSignature')}
                style={{
                  marginTop: '10px',
                  padding: '8px 16px',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                दस्तखत जनरेट गर्नुहोस्
              </button>
            </div>
                     </div>
           <div style={{ textAlign: 'center', marginTop: '30px' }}>
             <button 
               onClick={saveSignatures}
               className={styles['submit-btn']}
               style={{ 
                 padding: '12px 30px',
                 border: 'none',
                 borderRadius: '25px',
                 fontSize: '16px',
                 fontWeight: '600',
                 cursor: 'pointer',
                 background: 'linear-gradient(135deg, #28a745, #20c997)',
                 color: 'white',
                 boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
               }}
             >
               दस्तखतहरु सेभ गर्नुहोस्
             </button>
           </div>
         </div>
       )}

      {/* Main Form */}
      {activeTab === 'main' && (
        <>
          <div className={styles.header}>
            <div className={styles.logo}>
              <img src={mwuLogo} alt="MWU Logo" className={styles.logoImage} />
            </div>
            <span className={styles.right}>म.ले.प.फा.नं. ४०२</span>
            <div className={styles.clear}></div>
            <div className={styles.center}>
              <p className={styles.universityName}>मध्यपश्चिम विश्वबिद्यालय</p>
              <p className={styles.officeName}>
                <input 
                  type="text" 
                  value={formData.office}
                  onChange={(e) => {
                    handleInputChange('office', e.target.value);
                    handleInputResize(e);
                  }}
                  placeholder={formData.office ? '' : "कार्यालयको नाम"}
                  style={{
                    minWidth: '80px',
                    width: formData.office ? `${Math.max(80, formData.office.length * 8 + 20)}px` : '120px',
                    maxWidth: '400px',
                    marginRight: '5px'
                  }}
                /> कार्यालय
              </p>
              <p className={styles.officeAddress}>
                <input 
                  type="text" 
                  value={formData.officeAddress}
                  onChange={(e) => {
                    handleInputChange('officeAddress', e.target.value);
                    handleInputResize(e);
                  }}
                  placeholder={formData.officeAddress ? '' : "कार्यालयको ठेगाना"}
                  style={{
                    minWidth: '120px',
                    width: formData.officeAddress ? `${Math.max(120, formData.officeAddress.length * 8 + 20)}px` : '150px',
                    maxWidth: '500px'
                  }}
                />
              </p>
              <p className={styles.officeCode}>
                कार्यालय कोड नं.: <input 
                  type="text" 
                  value={formData.officeCode}
                  onChange={(e) => handleInputChange('officeCode', e.target.value)}
                  placeholder={formData.officeCode ? '' : "कोड नंबर"}
                />
              </p>
              <p style={{textAlign: 'center', fontWeight: 'bold', fontSize: '16px', margin: '10px 0'}}>खरिद आदेश</p>
            </div>
          </div>

             <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>
         {/* Left block */}
         <div style={{textAlign: 'left', flex: 1}}>
                       <p>श्री <input 
              type="text"
              value={formData.personName}
              onChange={(e) => handleInputChangeWithResize('personName', e.target.value, e)}
              placeholder={formData.personName ? '' : "व्यक्तिको नाम"}
            /></p>
                       <p>आदेश गरिएको व्यक्ति/निकायको नाम: <input 
              type="text"
              value={formData.entityName}
              onChange={(e) => handleInputChangeWithResize('entityName', e.target.value, e)}
              placeholder={formData.entityName ? '' : "व्यक्ति/निकायको नाम"}
            /></p>
                       <p>ठेगाना : <input 
              type="text"
              value={formData.address}
              onChange={(e) => handleInputChangeWithResize('address', e.target.value, e)}
              placeholder={formData.address ? '' : "ठेगाना"}
            /> &emsp; फोन नं: <input 
              type="text"
              value={formData.phoneNumber}
              onChange={(e) => handleInputChangeWithResize('phoneNumber', e.target.value, e)}
              placeholder={formData.phoneNumber ? '' : "फोन नंबर"}
            /></p>
            <p>सस्था दर्ता नं: <input 
              type="text"
              value={formData.registrationNumber}
              onChange={(e) => handleInputChangeWithResize('registrationNumber', e.target.value, e)}
              placeholder={formData.registrationNumber ? '' : "दर्ता नंबर"}
            /> &emsp; प्यान नं: <input 
              type="text"
              value={formData.panNumber}
              onChange={(e) => handleInputChangeWithResize('panNumber', e.target.value, e)}
              placeholder={formData.panNumber ? '' : "प्यान नंबर"}
            /></p>
         </div>
         {/* Right block */}
         <div style={{textAlign: 'right', flex: 1}}>
                       <p>दारिद आदेश नं : <input 
              type="text"
              value={formData.orderNumber}
              onChange={(e) => handleInputChangeWithResize('orderNumber', e.target.value, e)}
              placeholder={formData.orderNumber ? '' : "आदेश नंबर"}
            /></p>
            <p>खरिद आदेश मिति : <input 
              type="text"
              value={formData.orderDate}
              onChange={(e) => handleInputChangeWithResize('orderDate', e.target.value, e)}
              placeholder={formData.orderDate ? '' : "मिति"}
            /></p>
            <p>खरिद सम्वन्धि निर्णय नं : <input 
              type="text"
              value={formData.decisionNumber}
              onChange={(e) => handleInputChangeWithResize('decisionNumber', e.target.value, e)}
              placeholder={formData.decisionNumber ? '' : "निर्णय नंबर"}
            /></p>
            <p>निवेदन मिति : <input 
              type="text"
              value={formData.applicationDate}
              onChange={(e) => handleInputChangeWithResize('applicationDate', e.target.value, e)}
              placeholder={formData.applicationDate ? '' : "मिति"}
            /></p>
         </div>
       </div>

      <table className={styles.table}>
                 <thead>
           <tr>
             <th rowSpan="2">क्र.सं.</th>
             <th colSpan="5">सामानको</th>
             <th colSpan="2">मूल्य</th>
             <th rowSpan="2">कैफियत</th>
             <th rowSpan="2">कार्य</th>
           </tr>
           <tr>
             <th>जिन्सी वर्गीकरण संकेत नं</th>
             <th>नाम</th>
             <th>स्पेसिफिकेशन</th>
             <th>इकाई</th>
             <th>परिमाण</th>
             <th>दर</th>
             <th>जम्मा</th>
           </tr>
         </thead>
        <tbody>
                     {/* First row with numbers १-९ */}
           <tr>
             <td>१</td>
             <td>२</td>
             <td>३</td>
             <td>४</td>
             <td>५</td>
             <td>६</td>
             <td>७</td>
             <td>८</td>
             <td>९</td>
             <td></td>
           </tr>
          
                                                                 {/* Empty rows with serial numbers - now deletable */}
             {emptyRows.map((row) => (
               <tr key={row.id}>
                 <td>{row.serialNumber}</td>
                 <td><input 
                   type="text" 
                   value={row.classificationCode}
                   onChange={(e) => handleEmptyRowChange(row.id, 'classificationCode', e.target.value)}
                 /></td>
                 <td><input 
                   type="text" 
                   value={row.itemName}
                   onChange={(e) => handleEmptyRowChange(row.id, 'itemName', e.target.value)}
                 /></td>
                 <td><input 
                   type="text" 
                   value={row.specification}
                   onChange={(e) => handleEmptyRowChange(row.id, 'specification', e.target.value)}
                 /></td>
                 <td><input 
                   type="text" 
                   value={row.unit}
                   onChange={(e) => handleEmptyRowChange(row.id, 'unit', e.target.value)}
                 /></td>
                 <td><input 
                   type="text" 
                   value={row.quantity}
                   onChange={(e) => handleEmptyRowChange(row.id, 'quantity', e.target.value)}
                 /></td>
                 <td><input 
                   type="text" 
                   value={row.rate}
                   onChange={(e) => handleEmptyRowChange(row.id, 'rate', e.target.value)}
                 /></td>
                 <td><input 
                   type="text" 
                   value={row.total}
                   onChange={(e) => handleEmptyRowChange(row.id, 'total', e.target.value)}
                 /></td>
                 <td><input 
                   type="text" 
                   value={row.remarks}
                   onChange={(e) => handleEmptyRowChange(row.id, 'remarks', e.target.value)}
                 /></td>
                 <td>
                   <button 
                     type="button"
                     onClick={() => removeEmptyRow(row.id)}
                     style={{
                       padding: '4px 8px',
                       backgroundColor: '#dc3545',
                       color: 'white',
                       border: 'none',
                       borderRadius: '4px',
                       cursor: 'pointer',
                       fontSize: '12px',
                       fontWeight: 'bold'
                     }}
                     title="पङ्क्ति मेटाउनुहोस्"
                   >
                     ✕
                   </button>
                 </td>
               </tr>
             ))}

                       {/* Dynamic rows added by user */}
            {dynamicRows.map((row) => (
              <tr key={row.id}>
                <td>{row.serialNumber}</td>
                <td><input 
                  type="text" 
                  value={row.classificationCode}
                  onChange={(e) => handleDynamicRowChange(row.id, 'classificationCode', e.target.value)}
                /></td>
                <td><input 
                  type="text" 
                  value={row.itemName}
                  onChange={(e) => handleDynamicRowChange(row.id, 'itemName', e.target.value)}
                /></td>
                <td><input 
                  type="text" 
                  value={row.specification}
                  onChange={(e) => handleDynamicRowChange(row.id, 'specification', e.target.value)}
                /></td>
                <td><input 
                  type="text" 
                  value={row.unit}
                  onChange={(e) => handleDynamicRowChange(row.id, 'unit', e.target.value)}
                /></td>
                <td><input 
                  type="text" 
                  value={row.quantity}
                  onChange={(e) => handleDynamicRowChange(row.id, 'quantity', e.target.value)}
                /></td>
                <td><input 
                  type="text" 
                  value={row.rate}
                  onChange={(e) => handleDynamicRowChange(row.id, 'rate', e.target.value)}
                /></td>
                <td><input 
                  type="text" 
                  value={row.total}
                  onChange={(e) => handleDynamicRowChange(row.id, 'total', e.target.value)}
                /></td>
                <td><input 
                  type="text" 
                  value={row.remarks}
                  onChange={(e) => handleDynamicRowChange(row.id, 'remarks', e.target.value)}
                /></td>
                <td>
                  <button 
                    type="button"
                    onClick={() => removeDynamicRow(row.id)}
                    style={{
                      padding: '4px 8px',
                      backgroundColor: '#dc3545',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                    title="पङ्क्ति मेटाउनुहोस्"
                  >
                    ✕
                  </button>
                </td>
              </tr>
            ))}
                                           <tr>
              <td></td>
              <td>जम्मा रकम</td>
              <td><input 
                type="text"
                value={formData.totalAmount}
                onChange={(e) => handleInputChange('totalAmount', e.target.value)}
              /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>मू.अ.कर (१३%)</td>
              <td><input 
                type="text"
                value={formData.vatAmount}
                onChange={(e) => handleInputChange('vatAmount', e.target.value)}
              /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>कुल जम्मा रकम:</td>
              <td><input 
                type="text"
                value={formData.grandTotal}
                onChange={(e) => handleInputChange('grandTotal', e.target.value)}
              /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td><input type="text" /></td>
              <td></td>
            </tr>
                 </tbody>
       </table>
       
       {/* Add Row Button */}
       <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px' }}>
         <button 
           type="button"
           onClick={addDynamicRow}
           style={{
             padding: '10px 20px',
             backgroundColor: '#007bff',
             color: 'white',
             border: 'none',
             borderRadius: '5px',
             cursor: 'pointer',
             fontSize: '14px',
             fontWeight: '500'
           }}
         >
           ➕ पङ्क्ति थप्नुहोस् (Add Row)
         </button>
       </div>

             <p className={styles.notes}>
         माथि उल्लिखित सामानहरु मिति <input 
           type="text"
           value={formData.deliveryDate}
           onChange={(e) => handleInputChange('deliveryDate', e.target.value)}
           placeholder={formData.deliveryDate ? '' : "मिति"}
         /> भित्र <input 
           type="text"
           value={formData.deliveryOffice}
           onChange={(e) => handleInputChange('deliveryOffice', e.target.value)}
           placeholder={formData.deliveryOffice ? '' : "कार्यालय"}
         /> कार्यालय <input 
           type="text"
           value={formData.deliveryLocation}
           onChange={(e) => handleInputChange('deliveryLocation', e.target.value)}
           placeholder={formData.deliveryLocation ? '' : "स्थान"}
         /> स्थानमा दाखिला गरी बिल | इन्भाइस प्रस्तुत गर्नुहोला
       </p>

      <div className={styles.ddd}>
        <p>उपरोक्त अनुसार खरिद आदेश जारी गर्न, सिफारिस गर्ने स्वीकृत गर्ने :</p>
                 <div className={styles.signature}>
                                               <div>
               <p>
                                   <span 
                    onClick={() => toggleSignatureVisibility('fontwalSignature')}
                    style={{ 
                      cursor: 'pointer', 
                      color: signatureVisibility.fontwalSignature ? '#007bff' : '#000'
                    }}
                  >
                    फाँटवालाको दस्तखत:
                  </span> 
                 {signatures.fontwalSignature && signatureVisibility.fontwalSignature && (
                   <img 
                     src={signatures.fontwalSignature.preview} 
                     alt="फाँटवालाको दस्तखत" 
                     style={{ 
                       maxWidth: '120px', 
                       maxHeight: '60px', 
                       objectFit: 'contain',
                       marginLeft: '10px',
                       verticalAlign: 'middle',
                       border: '1px solid #ccc',
                       borderRadius: '4px',
                       background: 'white',
                       padding: '2px'
                     }}
                   />
                 )}
               </p>
              <p>नाम: <input 
                type="text"
                value={formData.fontwalName}
                onChange={(e) => handleInputChange('fontwalName', e.target.value)}
                placeholder={formData.fontwalName ? '' : "नाम"}
              /></p>
              <p>मिति: <input 
                type="text"
                value={formData.fontwalDate}
                onChange={(e) => handleInputChange('fontwalDate', e.target.value)}
                placeholder={formData.fontwalDate ? '' : "मिति"}
              /></p>
            </div>
                                               <div>
               <p>
                                   <span 
                    onClick={() => toggleSignatureVisibility('branchHeadSignature')}
                    style={{ 
                      cursor: 'pointer', 
                      color: signatureVisibility.branchHeadSignature ? '#007bff' : '#000'
                    }}
                  >
                    शाखा प्रमुखको दस्तखत:
                  </span> 
                 {signatures.branchHeadSignature && signatureVisibility.branchHeadSignature && (
                   <img 
                     src={signatures.branchHeadSignature.preview} 
                     alt="शाखा प्रमुखको दस्तखत" 
                     style={{ 
                       maxWidth: '120px', 
                       maxHeight: '60px', 
                       objectFit: 'contain',
                       marginLeft: '10px',
                       verticalAlign: 'middle',
                       border: '1px solid #ccc',
                       borderRadius: '4px',
                       background: 'white',
                       padding: '2px'
                     }}
                   />
                 )}
               </p>
              <p>नाम: <input 
                type="text"
                value={formData.branchHeadName}
                onChange={(e) => handleInputChange('branchHeadName', e.target.value)}
                placeholder={formData.branchHeadName ? '' : "नाम"}
              /></p>
              <p>मिति: <input 
                type="text"
                value={formData.branchHeadDate}
                onChange={(e) => handleInputChange('branchHeadDate', e.target.value)}
                placeholder={formData.branchHeadDate ? '' : "मिति"}
              /></p>
            </div>
                                               <div>
               <p>
                                   <span 
                    onClick={() => toggleSignatureVisibility('officeHeadSignature')}
                    style={{ 
                      cursor: 'pointer', 
                      color: signatureVisibility.officeHeadSignature ? '#007bff' : '#000'
                    }}
                  >
                    कार्यालय प्रमुखको दस्तखत:
                  </span> 
                 {signatures.officeHeadSignature && signatureVisibility.officeHeadSignature && (
                   <img 
                     src={signatures.officeHeadSignature.preview} 
                     alt="कार्यालय प्रमुखको दस्तखत" 
                     style={{ 
                       maxWidth: '120px', 
                       maxHeight: '60px', 
                       objectFit: 'contain',
                       marginLeft: '10px',
                       verticalAlign: 'middle',
                       border: '1px solid #ccc',
                       borderRadius: '4px',
                       background: 'white',
                       padding: '2px'
                     }}
                   />
                 )}
               </p>
              <p>नाम: <input 
                type="text"
                value={formData.officeHeadName}
                onChange={(e) => handleInputChange('officeHeadName', e.target.value)}
                placeholder={formData.officeHeadName ? '' : "नाम"}
              /></p>
              <p>मिति: <input 
                type="text"
                value={formData.officeHeadDate}
                onChange={(e) => handleInputChange('officeHeadDate', e.target.value)}
                placeholder={formData.officeHeadDate ? '' : "मिति"}
              /></p>
            </div>
         </div>
      </div>

             <p className={styles.notes}>
         माथि उल्लिखित सामानहरु मिति <input 
           type="text"
           value={formData.deliveryDate2}
           onChange={(e) => handleInputChange('deliveryDate2', e.target.value)}
           placeholder={formData.deliveryDate2 ? '' : "मिति"}
         /> भित्र <input 
           type="text"
           value={formData.deliveryOffice2}
           onChange={(e) => handleInputChange('deliveryOffice2', e.target.value)}
           placeholder={formData.deliveryOffice2 ? '' : "कार्यालय"}
         /> कार्यालयमा उपलब्ध गराइदिनु हुन अनुरोध छ ।
       </p>

      <div className={styles.signature} style={{justifyContent: 'flex-start'}}>
        <div className={styles.deip}>
                     <p><input 
             type="text"
             value={formData.firmName}
             onChange={(e) => handleInputChange('firmName', e.target.value)}
             placeholder={formData.firmName ? '' : "फर्मको नाम"}
           />फर्मको नाम </p>
           <p><input 
             type="text"
             value={formData.firmSignature}
             onChange={(e) => handleInputChange('firmSignature', e.target.value)}
             placeholder={formData.firmSignature ? '' : "दस्तखत र छाप"}
           />दस्तखत र छाप </p>
           <p><input 
             type="text"
             value={formData.firmDate}
             onChange={(e) => handleInputChange('firmDate', e.target.value)}
             placeholder={formData.firmDate ? '' : "मिति"}
           />मिति </p>
        </div>
      </div>

                           <div className={styles['form-actions']}>
          <button 
            type="button" 
            onClick={handleSubmit} 
            className={styles['submit-btn']}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'सेभ गर्दै...' : 'फारम सेभ गर्नुहोस्'}
          </button>
          <button type="button" className={styles['print-btn']}>
            प्रिन्ट गर्नुहोस्
          </button>
        </div>
       </>
     )}
   </div>
 );
};

export default Form402;